export default __webpack_public_path__ + "static/media/func-feature.086d7ecb.png";